import Cookies from 'js-cookie';
class NotificationManager {
    elems;
    constructor() {
        this.elems = $('.js-NotificationOverlay');
        if (!this.elems.length)
            return;
        // Disables closing the overlay when swiping the overlay away or clicking outside the overlay
        this.elems.on('mousedown touchstart touchmove touchend', e => {
            if (e.target !== e.currentTarget)
                return;
            e.stopImmediatePropagation();
        });
        (async () => {
            await new Promise(resolve => setTimeout(resolve, 2000));
            const { overlayManager } = await import('./overlay');
            this.elems.each((_i, elem) => {
                overlayManager.open($(elem), {
                    onClose: () => {
                        this.onClose($(elem));
                    }
                });
            });
        })();
    }
    onClose(elem) {
        const name = elem.data('cookie-name');
        const expirationDays = elem.data('cookie-expiration-days');
        if (!name || (!expirationDays || !Number.isInteger(expirationDays))) {
            console.warn('Cannot set notification closed cookie. data-cookie-name and/or data-cookie-expiration-days attribute(s) are invalid');
            return;
        }
        Cookies.set(name, 'true', { expires: expirationDays });
    }
}
export default new NotificationManager();
